import { render, staticRenderFns } from "./RollSelectBehaviorEditor.vue?vue&type=template&id=13813b44&scoped=true&"
import script from "./RollSelectBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./RollSelectBehaviorEditor.vue?vue&type=script&lang=ts&"
import style0 from "./RollSelectBehaviorEditor.vue?vue&type=style&index=0&id=13813b44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13813b44",
  null
  
)

export default component.exports